var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectronicSignatureNew = function SvgElectronicSignatureNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.917 6.667h-37.75C9.217 6.667 6 9.883 6 13.833v26.642c0 3.95 3.217 7.167 7.167 7.167h12.9l-4.309 4.308a5.47 5.47 0 0 0-5.358 5.458v1.334h31.275v-1.334a5.47 5.47 0 0 0-5.467-5.466h-.2l-4.3-4.3h13.2c3.95 0 7.167-3.217 7.167-7.167V13.833c0-3.95-3.217-7.166-7.167-7.166zM13.175 9.333h37.742c2.483 0 4.5 2.017 4.5 4.5v24.042H8.667V13.833c0-2.483 2.016-4.5 4.5-4.5zm31.5 46.742H19.417a2.8 2.8 0 0 1 2.458-1.467h20.342c1.058 0 1.983.592 2.458 1.467m-6.425-4.133H25.542l4.3-4.3h4.1l4.3 4.3zm12.667-6.967h-37.75a4.505 4.505 0 0 1-4.5-4.433H55.4a4.5 4.5 0 0 1-4.5 4.433z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 23.26H13.333v2.667H40zM40 17.333H13.333V20H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M44 12h-1.333v17.313c-.004.248.061.501.203.728l3.337 5.333a1.334 1.334 0 0 0 2.261-.001l3.33-5.334c.141-.226.206-.478.202-.726V12h-8m5.095 17.333h-3.522l1.763 2.818zm-3.761-2.666v-12h4v12z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export { SvgElectronicSignatureNew as Icon };
export default __webpack_public_path__ + "static/media/3082609e6c862aedfa925db2a7352bcb.svg";